export default __webpack_public_path__ + "media/images/logo-5a595a845f0345a96db7af26c95b467b.svg";